export enum GlobalEvent {
  CALL_STATUS_UPDATED = "call-status-updated",
}
